import { v4 as uuidv4 } from 'uuid';

export const formatTimestamp = (timestamp: string) => {
  return new Date(timestamp).toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
  });
};

export const copyToClipboard = async (text: string): Promise<boolean> => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (err) {
    console.error('Failed to copy:', err);
    return false;
  }
};


// export const generateUniqueKey = (userEmail: string, timestamp: string): string => {
//   const combinedString = `${userEmail}+${timestamp}`;
//   const hashedKey = SHA256(combinedString).toString();
//   return hashedKey;
// };


export const generateUniqueKey = (): string => uuidv4();